export default "__VITE_ASSET__CWJioeyn__"